import { Alert, Button, Col, Layout, Row, SiderProps, Upload, Tooltip, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
// import FeatherIcon from "feather-icons-react";
import { EditOutlined } from '@ant-design/icons';
import { OrganizationsApi } from 'api/clients/organizations-api'; // Adjust import path as needed
import { useCheckRouteAccess } from 'hooks/useCheckRouteAccess';
import { decodeJWT } from 'utility/decode-jwt';
import isOrganizationUser from 'utility/isOrganizationUser';
import MenuItems from '../../components/layout/MenuItems';
import TopMenu from '../../components/layout/TopMenu';
import { Div } from '../../components/layout/style';
import AuthInfo from '../../components/utilities/auth-info/info';
import { updateFavicon, updatePageTitle } from 'utility/utility';
import config from 'config/config';
import { useTranslation } from 'react-i18next';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { LocalStorageKeys } from 'hooks/useLocalStorage';
import { useMediaQuery } from 'react-responsive';

const { Header, Sider, Content } = Layout;
const { theme, topMenu, darkMode, rtl } = config;

const SideBarStyle: SiderProps['style'] = {
  margin: '63px 0 0 0',
  padding: '15px 15px 55px 15px',
  overflowY: 'auto',
  height: '100vh',
  position: 'fixed',
  left: 0,
  zIndex: 998,
  display: 'flex',
  flexDirection: 'column',
};

const organizationsApi = new OrganizationsApi();
export const AppLayout = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [collapsed, setCollapsed] = useState(isMobile);
  const location = useLocation();
  const [organizationName, setOrganizationName] = useState<string>('Chronos CRM');
  const [organizationId, setOrganizationId] = useState<string | null>(null);
  const [logoLoading, setLogoLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toggleCollapsed = () => setCollapsed(prev => !prev);
  useCheckRouteAccess();
  const [logoUrl, setLogoUrl] = useState<string | null>(null);
  const [localStorageUser, , , , updateNestedValue] = useLocalStorage(LocalStorageKeys.user, null) as any;

  useEffect(() => {
    let user = decodeJWT() as any;
    if (!user) {
      navigate('/login', { replace: true });
    } else {
      if (isOrganizationUser()) {
        if (localStorageUser?.organization?.name) {
          setOrganizationName(localStorageUser.organization.name);
        } else {
          setOrganizationName(user.organizationName);
        }
        setOrganizationId(user.organizationId);
      }
    }
  }, []);

  useEffect(() => {
    const fetchLogo = async () => {
      const user = localStorage.getItem('user');
      if (!user) return;

      try {
        setLogoLoading(true);
        const response = await organizationsApi.apiOrganizationsMeLogoGet();
        setLogoUrl(response.data);
      } catch (error) {
        console.error('Failed to fetch logo:', error);
      } finally {
        setLogoLoading(false);
      }
    };

    fetchLogo();
  }, []);

  const handleLogoUpload = async (file: File) => {
    try {
      await organizationsApi.apiOrganizationsIdLogoPost({
        id: Number(organizationId),
        organizationId: Number(organizationId),
        file: file,
      });
      // Refresh logo after upload
      const response = await organizationsApi.apiOrganizationsMeLogoGet();
      setLogoUrl(response.data);
    } catch (error) {
      console.error('Failed to upload logo:', error);
    }
  };

  useEffect(() => {
    updatePageTitle(organizationName);
  }, [organizationName]);

  useEffect(() => {
    updateFavicon(logoUrl || undefined);
  }, [logoUrl]);

  // Update collapsed state when screen size changes
  useEffect(() => {
    setCollapsed(isMobile);
  }, [isMobile]);

  // Collapse menu on route change in mobile mode
  useEffect(() => {
    if (isMobile) {
      setCollapsed(true);
    }
  }, [location, isMobile]);

  return (
    <Div>
      <Layout className="layout">
        <Header
          style={{
            position: 'fixed',
            width: '100%',
            top: 0,
            [!rtl ? 'left' : 'right']: 0,
          }}
        >
          <Row>
            <Col lg={!topMenu ? 4 : 3} md={12} sm={8} xs={12} className="align-center-v navbar-brand">
              {!topMenu || window.innerWidth <= 991 ? (
                <Button type="link" onClick={toggleCollapsed}>
                  <img src={require(`../../static/img/icon/${collapsed ? 'right.svg' : 'left.svg'}`)} alt="menu" />
                </Button>
              ) : null}
              <Link className={topMenu && window.innerWidth > 991 ? 'striking-logo top-menu' : 'striking-logo'} to="/">
                <div style={{ position: 'relative', display: 'inline-block' }}>
                  {organizationName && (
                    <span
                      style={{
                        fontSize: 22,
                        fontWeight: '700',
                        color: 'rgba(0, 0, 0, 0.85)',
                      }}
                    >
                      {organizationName}
                    </span>
                  )}
                </div>
              </Link>
            </Col>

            <Col lg={!topMenu ? 14 : 15} md={8} sm={0} xs={0}>
              {topMenu && window.innerWidth > 991 ? <TopMenu /> : <></>}
            </Col>

            <Col lg={6} md={4} sm={16} xs={12}>
              <AuthInfo />
            </Col>
            {/* <Col md={0} sm={18} xs={12}>
              <div className="mobile-action">
                <Link className="btn-search" onClick={handleSearchHide} to="#">
                  {searchHide ? (
                    <FeatherIcon icon="search" />
                  ) : (
                    <FeatherIcon icon="x" />
                  )}
                </Link>
                <Link className="btn-auth" onClick={onShowHide} to="#">
                  <FeatherIcon icon="more-vertical" />
                </Link>
              </div>
            </Col> */}
          </Row>
        </Header>
        {/* <Header
          style={{
            position: "fixed",
            width: "100%",
            top: 0,
            left: 0,
          }}
        >
          <Row>
            <Col lg={3} sm={6} xs={12} className="align-center-v navbar-brand">
              {window.innerWidth <= 991 ? (
                <Button type="link" onClick={toggleCollapsed}>
                  <img
                    src={require(`../static/img/icon/${
                      collapsed ? "right.svg" : "left.svg"
                    }`)}
                    alt="menu"
                  />
                </Button>
              ) : null}
              <Link
                className={
                  window.innerWidth > 991
                    ? "striking-logo top-menu"
                    : "striking-logo"
                }
                to="/admin"
              >
                <img
                  src={require(`../static/img/Logo_Dark.svg`).default}
                  alt=""
                />
              </Link>
            </Col>
            <Col lg={6} md={10} sm={0} xs={0}></Col>
          </Row>
        </Header> */}
        <Layout style={{ borderWidth: 1 }}>
          <Sider width={280} style={SideBarStyle} collapsed={collapsed} theme={darkMode ? 'dark' : 'light'}>
            <div style={{ minHeight: '80%' }}>
              <MenuItems topMenu={topMenu} toggleCollapsed={toggleCollapsed} darkMode={darkMode} />
            </div>
            {isOrganizationUser() && (
              <div
                style={{
                  padding: '20px',
                  textAlign: 'center',
                  position: 'relative',
                  overflow: 'visible',
                }}
              >
                {logoUrl ? (
                  <img
                    src={logoUrl}
                    alt={organizationName || 'Organization logo'}
                    style={{
                      width: collapsed ? '40px' : '200px',
                      height: 'auto',
                      maxHeight: '100px',
                      objectFit: 'contain',
                      transition: 'width 0.3s',
                    }}
                  />
                ) : (
                  !logoLoading && (
                    <Upload
                      accept="image/*"
                      showUploadList={false}
                      customRequest={({ file }) => handleLogoUpload(file as File)}
                    >
                      <Tooltip title={t('side-bar:upload-logo', 'Upload organization logo')}>
                        <Button
                          type="link"
                          icon={<EditOutlined />}
                          style={{
                            backgroundColor: 'white',
                            padding: 4,
                            overflow: 'hidden',
                            minWidth: '36px',
                            height: '36px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          {t('side-bar:upload-logo', 'Upload Logo')}
                        </Button>
                      </Tooltip>
                    </Upload>
                  )
                )}
              </div>
            )}
          </Sider>
          <Layout className="atbd-main-layout" style={{ minHeight: '90vh' }}>
            <Content>
              <Outlet />
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </Div>
  );
};
